import React, { Component } from "react";
import { Col, Container, Form, NavItem, NavLink, Row } from "reactstrap";

class Subscribe extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <div className="text-center mb-5">
                  <h5 className="text-primary text-uppercase small-title">
                    Subscribe
                  </h5>
                  <h4 className="mb-3">GET NOTIFIED WHEN WE LAUNCH</h4>
                  <p>A crowdfunding platform for Ethiopians, By Ethiopians</p>
                </div>
              </Col>

              <Col xl={8} lg={10}>
                <div className="text-center">
                  <div className="subscribe">
                    <Form>
                      <div className="text-center mt-3 mt-md-0">
                        <NavItem>
                          <NavLink
                            href={"#home"}
                            className="btn btn-block btn-primary"
                          >
                            {" "}
                            Subscribe Us
                          </NavLink>
                        </NavItem>
                      </div>
                    </Form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Subscribe;
